"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FONT_STATUS_FAILED = exports.FONT_STATUS_LOADED = exports.FONT_STATUS_LOADING = void 0;

var _react = require("react");

var _fontfaceobserver = _interopRequireDefault(require("fontfaceobserver"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FONT_URL_BASE = 'https://fonts.bunny.net/css';

var getFontUrl = family => {
  var params = new URLSearchParams({
    family: "".concat(family, ":400,400i"),
    display: 'swap'
  });
  return "".concat(FONT_URL_BASE, "?").concat(params.toString());
};

var FONT_STATUS_LOADING = 'loading';
exports.FONT_STATUS_LOADING = FONT_STATUS_LOADING;
var FONT_STATUS_LOADED = 'loaded';
exports.FONT_STATUS_LOADED = FONT_STATUS_LOADED;
var FONT_STATUS_FAILED = 'failed';
/**
 * useBunnyFonts takes an array of fonts, and load them to browser
 *
 * @param {string[]} fonts List of fonts to load
 */

exports.FONT_STATUS_FAILED = FONT_STATUS_FAILED;

var useBunnyFonts = fonts => {
  var [status, setStatus] = (0, _react.useState)(FONT_STATUS_LOADED);
  (0, _react.useEffect)(() => {
    if (!fonts || fonts.length === 0) return () => {};
    var links = fonts.map(font => {
      var link = document.createElement('link');
      link.href = getFontUrl(font);
      link.rel = 'stylesheet';
      document.head.appendChild(link);
      return link;
    });
    setStatus(FONT_STATUS_LOADING);
    Promise.all(fonts.map(font => new _fontfaceobserver.default(font).load())).then(() => setStatus(FONT_STATUS_LOADED)).catch(() => setStatus(FONT_STATUS_FAILED));
    return () => {
      links.forEach(link => document.head.removeChild(link));
    };
  }, [fonts]);
  return {
    status
  };
};

var _default = useBunnyFonts;
exports.default = _default;